/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiMessage } from '../../asyncapi/models/AaiMessage';
import { AaiOperation } from '../../asyncapi/models/AaiOperation';
import { AbstractCommand } from '../AbstractCommand';
import { JsonCompat } from '../../compat/JsonCompat';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { Node } from '../../core/models/Node';

/**
 * A command used to change the $ref inside an AsyncAPI message payload.
 * @author laurent.broudoux@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class ChangePayloadRefCommand_Aai20 extends AbstractCommand {
    public _operationPath : NodePath;

    public _messagePath : NodePath;

    public _payloadRef : string;

    public _oldPayloadRef : string;

    public _changed : boolean;

    public constructor(payloadRef? : any, operationNode? : any) {
        if(((typeof payloadRef === 'string') || payloadRef === null) && ((operationNode != null && operationNode instanceof <any>AaiOperation) || operationNode === null)) {
            let __args = arguments;
            super();
            if(this._operationPath===undefined) this._operationPath = null;
            if(this._messagePath===undefined) this._messagePath = null;
            if(this._payloadRef===undefined) this._payloadRef = null;
            if(this._changed===undefined) this._changed = false;
            this._oldPayloadRef = null;
            if(this._operationPath===undefined) this._operationPath = null;
            if(this._messagePath===undefined) this._messagePath = null;
            if(this._payloadRef===undefined) this._payloadRef = null;
            if(this._changed===undefined) this._changed = false;
            (() => {
                this._operationPath = Library.createNodePath(operationNode);
                this._payloadRef = payloadRef;
            })();
        } else if(((typeof payloadRef === 'string') || payloadRef === null) && ((operationNode != null && operationNode instanceof <any>AaiMessage) || operationNode === null)) {
            let __args = arguments;
            let messageNode : any = __args[1];
            super();
            if(this._operationPath===undefined) this._operationPath = null;
            if(this._messagePath===undefined) this._messagePath = null;
            if(this._payloadRef===undefined) this._payloadRef = null;
            if(this._changed===undefined) this._changed = false;
            this._oldPayloadRef = null;
            if(this._operationPath===undefined) this._operationPath = null;
            if(this._messagePath===undefined) this._messagePath = null;
            if(this._payloadRef===undefined) this._payloadRef = null;
            if(this._changed===undefined) this._changed = false;
            (() => {
                this._messagePath = Library.createNodePath(messageNode);
                this._payloadRef = payloadRef;
            })();
        } else if(payloadRef === undefined && operationNode === undefined) {
            let __args = arguments;
            super();
            if(this._operationPath===undefined) this._operationPath = null;
            if(this._messagePath===undefined) this._messagePath = null;
            if(this._payloadRef===undefined) this._payloadRef = null;
            if(this._changed===undefined) this._changed = false;
            this._oldPayloadRef = null;
            if(this._operationPath===undefined) this._operationPath = null;
            if(this._messagePath===undefined) this._messagePath = null;
            if(this._payloadRef===undefined) this._payloadRef = null;
            if(this._changed===undefined) this._changed = false;
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[ChangePayloadRefCommand_Aai20] Executing.");
        this._changed = false;
        let message : AaiMessage;
        if(!this.isNullOrUndefined(this._operationPath)) {
            let operation : AaiOperation = <AaiOperation>this._operationPath.resolve(document);
            if(this.isNullOrUndefined(operation) || this.isNullOrUndefined(operation.message)) {
                return;
            }
            message = operation.message;
        } else {
            message = <AaiMessage>this._messagePath.resolve(document);
        }
        if(this.isNullOrUndefined(message)) {
            return;
        }
        let payload : any = message.payload;
        if(payload == null) {
            payload = JsonCompat.objectNode();
        }
        let oldValue : any = JsonCompat.getProperty(payload, "$ref");
        if(oldValue != null && JsonCompat.isString(oldValue)) {
            this._oldPayloadRef = JsonCompat.toString(oldValue);
        }
        JsonCompat.setProperty(payload, "$ref", this._payloadRef);
        this._changed = true;
    }

    /**
     * 
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[ChangePayloadRefCommand_Aai20] Reverting.");
        if(!this._changed) {
            return;
        }
        let message : AaiMessage;
        if(!this.isNullOrUndefined(this._operationPath)) {
            let operation : AaiOperation = <AaiOperation>this._operationPath.resolve(document);
            if(this.isNullOrUndefined(operation)) {
                return;
            }
            message = operation.message;
        } else {
            message = <AaiMessage>this._messagePath.resolve(document);
        }
        if(this.isNullOrUndefined(message)) {
            return;
        }
        let payload : any = message.payload;
        if(this._oldPayloadRef != null) {
            JsonCompat.setProperty(payload, "$ref", this._oldPayloadRef);
        } else {
            JsonCompat.consumeProperty(payload, "$ref");
        }
    }
}
ChangePayloadRefCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.ChangePayloadRefCommand_Aai20";
ChangePayloadRefCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




